import { useContext } from 'react';
import { AgentContext } from './AgentProvider';

export function useAgentContext() {
    return useContext(AgentContext);
}
